var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom"},[_vm._v("\n   Copyright©2014-2018 爱学习AIXUEXI.com 版权所有 | 京ICP证160734号 |\n   "),_c('a',{attrs:{"target":"_blank","href":"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802023874"}},[_c('i'),_vm._v("京公网安备11010802023874号  \n    ")])])
}]

export { render, staticRenderFns }